export default [
    {
        id: 1,
        q: `What IS DentiCalc?`,
        a: `DentiCalc is a revolutionary mobile app designed specifically for dentists to <b>create treatment plans</b> and to <b>provide treatment animations</b> in less than a minute.`,
        up: 125,
        down: 12,
    },
    {
        id: 2,
        q: `What means "4in1"?`,
        a: `DentiCalc includes 4 separate applications:<br/><br/>
        <ul>
            <li><b>Photos</b>, offering 1000+ dental photos to illustrate problems and solutions.</li>
            <li><b>Videos</b>, offering 100+ unique dental videos to explain or compare treatments.</li>
            <li><b>Calculator</b>, to give prices for your patients chairside.</li>
            <li><b>SMART</b>, to create treatment plans with personalized animations in seconds.</li>
        </ul>`,
        up: 68,
        down: 5,
    },
    {
        id: 3,
        q: `For WHOM do we recommend its use?`,
        a: `Dentists who perform <b>prosthetic or implant treatments</b>.`,
        up: 6,
        down: 2,
    },
    {
        id: 4,
        q: `WHEN should you use it?`,
        a: `We recommend it for <b>consultations</b>, particularly when you are talking to your patient about what <b>treatment option you are proposing</b>.`,
        up: 347,
        down: 9,
    },
    {
        id: 5,
        q: `WHY should you use it?`,
        a: `<ul>
        <li>You can use <b>animations to explain</b> the different prosthetic or implantation treatments to your patients.</li>
        <li>You can <b>give prices or plans</b> in less than a minute on the first consultation.
        </ul>`,
        up: 168,
        down: 12,
    },
    {
        id: 6,
        q: `Is it EASY to learn?`,
        a: `It's very easy to use, but like everything else, it takes <b>1 or 2 hours</b> to be able to use it <b>confidently</b>.`,
        up: 387,
        down: 8,
    },
    {
        id: 7,
        q: `HOW do you use it?`,
        a: `In our tutorial videos, we will <b>guide you through the use in detail</b>, illustrated with real-life examples.`,
        up: 76,
        down: 5,
    },
    {
        id: 8,
        q: `What DEVICES does it work on?`,
        a: `DentiCalc is designed for <b>mobile phones and tablets.</b>`,
        up: 35,
        down: 0,
    },
    /*{
        id: 9,
        q: `HOW MUCH does it cost?`,
        a: `$19.99 per month, which we think is a <b>very fair price</b> - especially as it includes 4 separate apps. Plus, you can use all 4 apps for free for a few days after downloading, with <b>no obligation</b>.`,
        up: 423,
        down: 11,
    },*/
    {
        id: 10,
        q: `How can I subscribe?`,
        a: `Once downloaded, you can use it for free for a few days to get familiar with it. After that click on “get premium” to start your subscription.<br/><br/>You can <b>pay via Google Play or the AppStore</b> in the same way as you would pay for any other mobile app.<br/><br/>If you've never purchased a phone app before, make sure you have the <b>correct card details set up.</b>`,
        up: 98,
        down: 7,
    },
];
